import ServiceBase from "base/baseService"
import { boolToNumber, toJSDate, toJSDatetime } from "helper/formater"
import * as yup from "yup"

export default class ProdutoService extends ServiceBase {

    title = "Produto"
    pluralTitle = "Produtos"
    url = '/cadastro/produto/produto'
    frontUrl = '/cadastro/produto/produto'
    frontUrlList = '/cadastro/produto/produtolist'
    primaryKey = 'codigo_prod'
    ignoredsSchemaConvertions = ['cod_marc_prod', 'cod_cor_prod', 'cod_tam_prod']

    prepareToFront(data = {}) {

        console.log('DATAx: ', data)

        data.ativo_prod = boolToNumber(data.ativo_prod, true)

        // Numéricos com FK notNullable

        data.cod_unid_prod = data?.cod_unid_prod || null

        // Strings notNullable

        data.referencia_prod = data?.referencia_prod || ''
        data.descricao_prod = data?.descricao_prod || ''
        data.ncm_prod = data?.ncm_prod || ''
        data.cest_prod = data?.cest_prod || ''
        data.cod_tipp_prod = data?.cod_tipp_prod || ''
        data.cod_orip_prod = data?.cod_orip_prod || ''
        data.cod_conp_prod = data?.cod_conp_prod || 'n'

        // Numéricos sem FK

        data.vida_util_meses_prod = data?.vida_util_meses_prod || 0
        data.peso_liquido_prod = data?.peso_liquido_prod || 0
        data.peso_bruto_prod = data?.peso_bruto_prod || 0
        data.vol_altura_prod = data?.vol_altura_prod || 0
        data.vol_comprimento_prod = data?.vol_comprimento_prod || 0
        data.vol_largura_prod = data?.vol_largura_prod || 0

        // Dependentes

        data.produto_fornecedor = data?.produto_fornecedor || []
        data.produto_empresa = data?.produto_empresa || {}
        data.produto_endereco = data?.produto_endereco || []

        // Datas
        data.venc_prod = toJSDate(data.venc_prod)

        data.produto_fornecedor.map(e => {
            e.dh_ult_compra_pfor = toJSDatetime(e.dh_ult_compra_pfor)
        })

        return data
    }

    prepareToSave({ data }) {

        /**
         * produto_fornecedor.cod_forn_pfor é objeto e deve retornar para number
         */
        data.produto_fornecedor.forEach(e => {
            if (e?.cod_forn_pfor?.codigo_pes)
                e.cod_forn_pfor = e.cod_forn_pfor.codigo_pes
            else if (e?.pessoa?.codigo_pes)
                e.cod_forn_pfor = e.pessoa.codigo_pes
            delete e?.pessoa
        })

        // // Teste mock
        // data.arquivo[0] = {
        //     "codigo_arq": 1,
        //     "cod_tiarq_arq": 1,
        //     "cod_siarq_arq": 1,
        //     "nome_original_arq": "Ventiladora.png",
        //     "tamanho_bytes_arq": 3241,
        //     "mime_type_arq": "image/png",
        //     "action": "upd",
        //     ...data.arquivo[0]
        // }

        return data

    }

    fornecedorToView({ pessoa }) {

        const view = {
            codigo_pes: pessoa.codigo_pes,
            nome_razao_pes: pessoa.nome_razao_pes,
            cpf_cnpj_pes: pessoa.cpf_cnpj_pes
        }

        return view

    }

    getNewProdutoFornecedor(data = {}) {
        return {
            action: 'ins',
            cod_forn_pfor: { codigo_pes: null, nome_razao_pes: '' },
            ref_fabr_pfor: null,
            cod_unid_compra_pfor: null,
            fator_convs_pfor: 1,
            valor_ult_compra_pfor: 0.0,
            dh_ult_compra_pfor: null,
            ...data
        }
    }

    getFieldShowFornecedor({ data = {} }) {
        if (data?.codigo_pes) {
            return `${data.nome_razao_pes} - ${(String(data?.codigo_pes) || '').slice(0, 4)}`
        }
        return ''
    }

    getItemTemplateFornecedor({ pessoa }) {

        const cp = pessoa?.cpf_cnpj_pes?.length > 11 ? 'CPF' : 'CNPJ'

        if (pessoa?.codigo_pes) {
            return pessoa.nome_razao_pes + ` - ${cp}: ` + (pessoa.cpf_cnpj_pes || '').slice(0, 4) + '... - ' + pessoa.codigo_pes
        }
        return ''

    }

    async getSchema() {

        return super.getSchema().then((data) => {

            if (data?.fields) {

                data.fields.produto_fornecedor.innerType.fields.cod_forn_pfor = yup.object()
                    .test('Fornecedor', 'Inválido', e => e.codigo_pes)
                    .typeError('Obrigatório')
                    .required('Obrigatório')
            }

            return data

        })

    }

}
